<template>
  <div>
    <modal-provider :title="$t('comparison_popup_title')" name="which-to-compare" width="700">
      <div v-if="popupInfo" class="which-to-compare">
        <div class="which-to-compare__wrapper custom-scrollbar">
          <div class="which-to-compare__item" v-for="(product, i) in popupInfo" :key="i">
            <div class="which-to-compare__item-info-wrapper">
              <img class="which-to-compare__item-img" :src="product.img_url" :alt="product.name" />
              <span class="which-to-compare__item-name">{{ product.name }}</span>
            </div>
            <AddToComparisonBtn :product-id="product.add_url" />
          </div>
        </div>
      </div>
    </modal-provider>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddToComparisonBtn from '@/components/product/product-comparison/AddToComparisonBtn'

export default {
  name: 'WhichToComparePopup',
  components: {
    AddToComparisonBtn
  },
  computed: {
    ...mapState({
      popupInfo: state => state.productComparison.whichToComparePopupInfo
    })
  }
}
</script>

<style scoped lang="sass">

.which-to-compare__item
  display: flex
  align-items: center
  justify-content: space-between

.which-to-compare__item-info-wrapper
  display: flex
  align-items: center

.which-to-compare__item-img
  width: 70px
  height: 70px

  +mmin($between-phone-tablet)
    width: 100px
    height: 100px

.which-to-compare__item-name
  font-size: 14px
  max-width: 65%
  margin-left: 20px

  +mmin($between-phone-tablet)
    font-size: 15px
    margin-left: 40px

.which-to-compare__wrapper
  max-height: 600px
  overflow-y: auto
</style>
